import { PostDetailPage } from '~/src/components/post'

export default function JobDetailPage() {

  return (
    <PostDetailPage />
  )
}